<template>
    <div>
        <error-page code="502" :description="description"></error-page>
    </div>
</template>

<script>
    import ErrorPage from './Error'
    
    export default {
        data: function() {
            return {
                description: 'The request took too long to process or has been canceled.',
            }
        },
        components: {
            ErrorPage,
        }
    }
</script>



// WEBPACK FOOTER //
// 502.vue?7da21ff4